import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment/min/moment-with-locales';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  /**
   * Takes a value and makes it lowercase.
   */
  transform(value, args?, type?, humanRead?) {
        let date = null;
        if (type) {
              date = moment(value, type);
        } else {
              date = moment(value);
        }
        date.locale('es');

        if (!humanRead) {
              return date.format(args);
        } else {
              return date.calendar(null, {
                    sameDay: '[Hoy]  h:mm A',
                    nextDay: '[Mañana]  h:mm A',
                    nextWeek: 'dddd  h:mm A',
                    lastDay: '[Ayer]  h:mm A',
                    lastWeek: '[El pasado] dddd  [a la(s)] h:mm A',
                    sameElse: 'MMMM DD[,] [a la(s)] h:mm A'
              });
        }
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pipes/date-format.pipe.ts